import React, {useEffect} from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

function Digits() {

    useEffect(() => {
        // Inicializa AOS solo cuando el componente se monta en el cliente
        AOS.init({
          duration: 1000,
          easing: 'ease-in-out',
        });
      }, []);

  return (
    <div className="Content__digits">
        <div className="container">
            <div className="Content__digits--title">
                <h2>Recibelo En Cifras</h2>
            </div>
            <div className="Content__digits--container" data-aos="zoom-in-up">
                <div className="Content__digits--item">
                    <div className="Content__digits--icon">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                    <div className="Content__digits--details">
                        <div className="Content__digits--name">
                            <h4>+3 Millones</h4>
                        </div>
                        <div className="Content__digits--description">
                            <p>Entregas</p>
                        </div>
                    </div>
                </div>
                <div className="Content__digits--item">
                    <div className="Content__digits--icon">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                    <div className="Content__digits--details">
                        <div className="Content__digits--name">
                            <h4>+97%</h4>
                        </div>
                        <div className="Content__digits--description">
                            <p>Efectividad De Entrega</p>
                        </div>
                    </div>
                </div>
                <div className="Content__digits--item">
                    <div className="Content__digits--icon">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                    <div className="Content__digits--details">
                        <div className="Content__digits--name">
                            <h4>+5 Años</h4>
                        </div>
                        <div className="Content__digits--description">
                            <p>De Experiencia</p>
                        </div>
                    </div>
                </div>
                <div className="Content__digits--item">
                    <div className="Content__digits--icon">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                    <div className="Content__digits--details">
                        <div className="Content__digits--name">
                            <h4>+200</h4>
                        </div>
                        <div className="Content__digits--description">
                            <p>Colaboradores</p>
                        </div>
                    </div>
                </div>
                <div className="Content__digits--item">
                    <div className="Content__digits--icon">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                    <div className="Content__digits--details">
                        <div className="Content__digits--name">
                            <h4>24/7</h4>
                        </div>
                        <div className="Content__digits--description">
                            <p>Asistencia</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export { Digits }